// src/stone/illustrations/StonjiCheckGreenIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var StonjiCheckGreenIllustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 64 64",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { fill: "#00A868", d: "M0 0h64v64H0z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M42 24.001a2.002 2.002 0 1 0 0-4.003A2.002 2.002 0 0 0 42 24M30.002 44.002a2.001 2.001 0 1 0 0-4.003 2.001 2.001 0 0 0 0 4.003M22 34.002a2.002 2.002 0 1 0 0-4.003 2.002 2.002 0 0 0 0 4.003"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#20252A",
          d: "M32 8.003a24 24 0 1 0 0 48.001 24 24 0 0 0 0-48.001m0 43.999a20.001 20.001 0 1 1 0-40.003 20.001 20.001 0 0 1 0 40.003"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "m23.605 30.963-3.127 2.494 7.983 10.007 3.127-2.494z"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#fff", d: "m43.905 22.929-3.43-2.057-11.994 20 3.43 2.058z" })
    ]
  }
);
var StonjiCheckGreenIllustration_default = StonjiCheckGreenIllustration;

export {
  StonjiCheckGreenIllustration_default
};
